module.exports = __webpack_public_path__ + "static/media/arrow-square-down.266d19d1.svg";